var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"text-center mt-5"},[_vm._v(" MagnetHandler ")])}
var staticRenderFns = []

export { render, staticRenderFns }